import React from 'react';
import banner from '../../assets/images/upgrade-plan-banner.png';
import {Button} from '../../ui-components/Button/button';
import {DollarIcon} from '../../ui-components/Iconpack';
import {useNavigate} from 'react-router-dom';

export const UpgradeCard = (props: {msg: string}) => {
    const {msg} = props;
    const navigate = useNavigate();

    return (
        <div className={'flex flex-col space-y-4'}>
            <img src={banner} alt={'upgrade-plan'} />
            <span className={'flex text-start text-white'}>{msg}</span>
            <Button variant={'primary'} className={'w-full'} onClick={() => navigate('/settings/plans')}>
                <DollarIcon />
                <span className={'text-[16px] font-[600]'}>View Plans</span>
            </Button>
        </div>
    );
};
